// Products page English translations

export default {
  pageTitle: "Products",
  breadcrumbHome: "Home",
  breadcrumbProducts: "Products",
  title: "Products",
  description: "Explore our range of high-quality sealing solutions and precision components designed for automotive, marine, aerospace, and general industry applications.",
  searchByCategory: "Search by \ncategory",
  searchByIndustry: "Search by \nIndustry",
  searchByKeyword: "Search by \nkeyword",
  enterKeywords: "Enter product keywords",
  allProducts: "All Products",
  allIndustries: "All Industries",
  items: "items",
  showingProductsFor: "Showing products for:",
  category: "Category",
  industry: "Industry",
  keyword: "Keyword",
  noProductsFound: "No products found",
  noProductsDescription: "There are no products available for the selected filter.",
  inquireNow: "Inquire Now",
  viewDetails: "View Details",
  cardView: "Card View",
  listView: "List View",
  
  // Categories
  mechanicalSeals: "Mechanical Seals",
  lipSeal: "Lip Seal",
  valves: "Valves",
  floatingSeal: "Floating Seal",
  accumulators: "Accumulators",
  waterLubricatedSternTubeSeal: "Water Lubricated Stern Tube Seal",
  waterLubricatedSternTubeBearing: "Water Lubricated Stern Tube Bearing",
  serviceEngineer: "Service Engineer",
  
  // Industries
  oilGas: "Oil, Gas & General Industry",
  automobile: "Automobile & Motorcycle",
  constructionAgriculture: "Construction & Agriculture",
  marine: "Marine",
  semiconductor: "Semiconductor",
  
  // Product Names
  eh795: "Mechanical Seal for Water Pump EH795/EH790",
  eh795Desc: "Capable for high-speed rotation. Mass-production by fully automated assembling lines and supplied to water pump makers worldwide. By its unitized design, EH795 supports easy installation into customer application.",
  lipSealAc: "Lip Seal For A/C Compressor",
  lipSealAcDesc: "Rotating shaft seals exclusively designed for car air-conditioning compressors. Eagle Industry's original design featuring compactness and high reliability. Helps eliminate CFC leakage causing global warming.",
  reedValve: "Reed Valve",
  reedValveDesc: "Designed for four-stroke motorcycle engines for emission control. Substantially reduces carbon monoxide and hydrocarbon emissions to mitigate air pollution.",
  airCutValve: "Air Cut Valve",
  airCutValveDesc: "Mounted on four-stroke motorcycle engines. Designed for exhaust gas emission regulation (secondary air supply).",
  floatingSeal: "Floating Seal",
  floatingSealDesc: "Seals for undercarriages of construction machinery. Simple structure consisting of an O-ring and a seal ring made of special cast iron. Optimum seals for undercarriages of bulldozers and hydraulic excavators.",
  superiorORing: "SUPERIOR O-Ring",
  superiorORingDesc: "Newly developed O-Ring material with better chemical resistance, low outgas generation, and light heat resistance for semiconductor process industry.",
  bladderAccumulator: "Bladder Type Accumulator",
  bladderAccumulatorDesc: "These standard bladder accumulators are manufactured based on years of experience and proven performance.",
  evk2rv: "Water Lubricated Stern Tube Seal - EVK",
  evk2rvDesc: "A compact, high performance water lubricated seal having excellent vibration resistance and sealing performance.",
  evk2rt: "Water Lubricated Stern Tube Seal - EVK2RT",
  evk2rtDesc: "A compact, high performance water lubricated seal having excellent vibration resistance and sealing performance. The EVK type seal is the easiest of the seals on the market for installation and operation. Spare ring is easily activated without disassembling.",
  mas: "Marine Ace Seal (MAS)",
  masDesc: "Water-lubricated stern seal for small vessels with direct drive systems. Features end-face seal structure for excellent sealing performance.",
  rudderSeal: "Rudder Seal (RSC)",
  rudderSealDesc: "Rudder seal manufacture with high-performance, self-lubricating lip seals designed to be mounted above the rudder bearing to prevent the ingress of sea water into the hull. Manufactured from a special rubber, provide long wear life with no need for periodic adjustments, operate with less drag and reduced shaft/liner wear.",
  evr: "Water Lubricated Stern Tube Bearing - EVR",
  evrDesc: "Excellent Durability and Vibration Absorption. Designed specifically for marine applications with water lubricated shafting systems.",
  evu: "Water Lubricated Stern Tube Bearing - EVU",
  evuDesc: "Poly-Urethane bearing developed for water lubricated stern tube systems based on our extensive water lubricated bearing technology and experience.",
  serviceEngineer: "Service Engineer",
  serviceEngineerDesc: "Professional engineering services for your ship's sealing systems. We provide highly skilled and experienced service engineers to handle all aspects of marine sealing."
};